export default __webpack_public_path__ + "assets/967ff0dc5bcbd87786d60d2a34188389.svg";